import { render } from "./SearchResultsList.vue?vue&type=template&id=276d126c"
import script from "./SearchResultsList.vue?vue&type=script&lang=js"
export * from "./SearchResultsList.vue?vue&type=script&lang=js"

import "./SearchResultsList.vue?vue&type=style&index=0&id=276d126c&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.7.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__